import { EditIcon, WebsiteIcon } from "modules/icons";
import { WebsitePage } from "modules/websites/websiteDetails/WebsitePage";
import { WebsiteFormPage } from "modules/websites/websiteForm/WebsiteFormPage";
import { WebsiteListPage } from "modules/websites/websitelist/WebsiteListPage";
import { USER_GROUPS } from "utils/constants";

export const templatewebsites = {
  key: "templatewebsites",
  path: "/templates/:templateID/websites",
  section: "template",
  title: "Webseiten",
  view: <WebsiteListPage routeKey="templatewebsites" />,
  icon: <WebsiteIcon />,
  groups: [USER_GROUPS.ADMIN, USER_GROUPS.OFFICE],
  level: 0,
  navigation: true,
  indented: false,
  isWithParam: false,
  subNavigations: {
    templatewebsitecreate: {
      key: "templatewebsitecreate",
      path: "/templates/:templateID/websites/create",
      section: "template",
      title: "Webseite anlegen",
      view: <WebsiteFormPage formIntent="create" routeKey="templatewebsites" />,
      icon: <WebsiteIcon />,
      groups: [USER_GROUPS.ADMIN, USER_GROUPS.OFFICE],
      level: 1,
      navigation: false,
      indented: false,
      isWithParam: false,
      subNavigations: {},
    },
    templatewebsite: {
      key: "templatewebsite",
      path: "/templates/:templateID/websites/:websiteID",
      section: "template",
      title: "Webseite",
      view: <WebsitePage routeKey="templatewebsites" />,
      icon: <WebsiteIcon />,
      groups: [USER_GROUPS.ADMIN, USER_GROUPS.OFFICE],
      level: 1,
      navigation: false,
      indented: false,
      isWithParam: true,
      subNavigations: {
        templatewebsiteedit: {
          key: "templatewebsiteedit",
          path: "/templates/:templateID/websites/:websiteID/edit",
          section: "template",
          title: "Webseite bearbeiten",
          view: (
            <WebsiteFormPage formIntent="edit" routeKey="templatewebsites" />
          ),
          icon: <EditIcon />,
          groups: [USER_GROUPS.ADMIN, USER_GROUPS.OFFICE],
          level: 2,
          navigation: true,
          indented: false,
          isWithParam: false,
          subNavigations: {},
        },
      },
    },
  },
};
